
/*
require.context and the try catch is parsed in building (webpack) time.
It has to receive js literals (the string can not be dynamic (no var, no argument) and
the try catch has to be wrapping de call.
 */
const retrieveCoreContext = () => {
    try {
        return require.context('../../../i18n', false, /\.json$/);
    } catch (e) {
        console.log(e);
    }
};


const retrieveAdaptationContext = () => {
    try {
        return require.context('../../../../../custom/i18n', false, /\.json$/);
    } catch (e) {
        console.log(e);
    }
};

const withContext = (retrieveContext) => (func) => (languageDir) => func(retrieveContext());

const getCustomMessages = (context) => context ? extractMessagesFromContext(context)  : {};
const languageCodeFrom = (fileName) => fileName.slice(2, -5);

const extractMessagesFromContext = (context) => context.keys().reduce((languages, fileName) => {
    languages[languageCodeFrom(fileName)] = context(fileName);
    return languages;
}, {});

export const getMessages = {
    fromCore: withContext(retrieveCoreContext)(getCustomMessages),
    fromAdaptation: withContext(retrieveAdaptationContext)(getCustomMessages)
};



// WEBPACK FOOTER //
// ./src/components/i18n/messagesProvider.js